define(["./nodeCommandsModule"],
    function (nodeCommandsModule) {
    "use strict";

    return nodeCommandsModule.service("nodeCommandMoveDeliveryUnitToAnotherUser", ["moveToAnotherUserModal", function (moveToAnotherUserModal) {
        return function (selection, isFromSelectView) {
            return moveToAnotherUserModal(selection, isFromSelectView);
        };
    }]);
});